module.exports = __webpack_public_path__ + "img/1-A-Clearing_1.0433119d.png";